import React from 'react';
import Loadable from 'react-loadable';
import PageLoader from 'ui/components/Loaders/PageLoader';

export default Loadable({
  loader: () => import('./index'),
  loading: loadableProps => <PageLoader isLoadable {...loadableProps} />,
  delay: 500, // Avoiding Flash Of Loading Component
  timeout: 10000, // Timing out when the loader is taking too long
});
